export enum WarningPurchaseAnimationStates {
  Inactive = 'inactive',
  Start = 'start',
  End = 'end'
}
